import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ResolveLocationDto } from '@models/profile/location/resolve-location';
import { ResolveLocationManualRequest } from '@models/profile/location/resolve-location-manual-request';
import { WorldLocation } from '@models/profile/location/world-location';
import { HttpService } from '@services/http.service';
import { SessionService } from '@services/utils/session.service';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class LocationService extends HttpService {
    private readonly sessionService = inject(SessionService);
    private readonly defaultEndpointParams: EndpointParams = { app: 'utilities', version: 1 };

    list(postalCode: string, countryCode: string): Observable<WorldLocation[]> {
        return this.get(`locations/list/${postalCode}/${countryCode}`, this.defaultEndpointParams);
    }

    resolve(placeId: string, sessionToken: string): Observable<ResolveLocationDto> {
        const centerToken = this.sessionService.getPublicToken();

        return this.post(`public/locations/resolve?centerToken=${centerToken}`, this.defaultEndpointParams, { placeId, sessionToken });
    }

    // Sin lugar de Google que resolver: el backend cataloga la localizacion con los componentes que
    // el socio ha escrito, por el mismo flujo de busqueda-o-creacion que `resolve`. Sin notificacion
    // de error: para el alta es un dato opcional (sin localizacion vale 0) y quien la pide sigue
    // adelante, asi que un fallo aqui no es nada que el socio pueda entender ni corregir.
    resolveManual(request: ResolveLocationManualRequest): Observable<ResolveLocationDto> {
        const centerToken = this.sessionService.getPublicToken();

        return this.post(`public/locations/resolve/manual?centerToken=${centerToken}`, this.defaultEndpointParams, request, this.noShowErrorNotification);
    }
}
